<template>
  <aside class="detail-section">
    <div class="nx-card-header detail-head">
      <div class="nx-card-title">轨迹详情</div>
    </div>
    <div class="detail-body">
      <div class="detail-card">
        <div class="detail-title">基本信息</div>
        <div class="detail-item">
          <span class="detail-label">工单编号</span>
          <span class="detail-value">{{ current.workOrderCode || '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">计划名称</span>
          <span class="detail-value">{{ current.extPlanName || '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">巡检路线</span>
          <span class="detail-value">{{ current.inspectionRouteName || '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">巡检人员</span>
          <span class="detail-value">{{ current.userName || '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">工单点位</span>
          <span class="detail-value">{{ workOrderPointCount(current) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">RTK设备</span>
          <span class="detail-value">{{ current.rtkId || (hasTrack ? '—' : '暂无轨迹') }}</span>
        </div>
      </div>
      <div class="detail-card">
        <div class="detail-title">轨迹统计</div>
        <div v-if="!hasTrack" class="no-track-note">暂无轨迹</div>
        <div class="stat-grid">
          <div class="stat-cell">
            <div class="stat-label">轨迹点</div>
            <div class="stat-value">{{ current.trackPointCount || 0 }} 个</div>
          </div>
          <div class="stat-cell">
            <div class="stat-label">总时长</div>
            <div class="stat-value">{{ formatMinutes(current.durationMinutes) }}</div>
          </div>
          <div class="stat-cell">
            <div class="stat-label">原始上报</div>
            <div class="stat-value">{{ current.totalReportCount || 0 }} 次</div>
          </div>
          <div class="stat-cell">
            <div class="stat-label">明细点</div>
            <div class="stat-value">{{ pointCount }} 个</div>
          </div>
        </div>
      </div>
      <div class="detail-card">
        <div class="detail-title">时间范围</div>
        <div class="detail-item">
          <span class="detail-label">工单开始</span>
          <span class="detail-value">{{ displayStartTime(current) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">工单结束</span>
          <span class="detail-value">{{ displayEndTime(current) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">轨迹开始</span>
          <span class="detail-value">{{ current.trackStartTime || '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">轨迹结束</span>
          <span class="detail-value">{{ current.trackEndTime || '—' }}</span>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'TraceDetail',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    current () {
      return this.detail || {}
    },
    pointCount () {
      return (this.current.trackPoints || []).length
    },
    hasTrack () {
      return Number(this.current.trackPointCount || 0) > 0 || this.pointCount > 0 || !!this.current.rtkId
    }
  },
  methods: {
    formatMinutes (val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      if (n < 60) return `${n}分钟`
      const h = Math.floor(n / 60)
      const m = n % 60
      return m > 0 ? `${h}小时${m}分钟` : `${h}小时`
    },
    displayStartTime (row) {
      if (!row) return '—'
      return row.workOrderStartTime || row.actualStartTime || row.cycleStartTime || row.createTime || '—'
    },
    displayEndTime (row) {
      if (!row) return '—'
      return row.workOrderEndTime || row.actualEndTime || row.cycleEndTime || row.updateTime || '—'
    },
    workOrderPointCount (row) {
      if (!row) return 0
      const planCount = row.planPointCount != null ? Number(row.planPointCount) : null
      const completedCount = row.completedPointCount != null ? Number(row.completedPointCount) : null
      const extCount = row.extPointCount != null ? Number(row.extPointCount) : 0
      if (planCount != null && !Number.isNaN(planCount)) {
        if (completedCount != null && !Number.isNaN(completedCount)) {
          return `${completedCount}/${planCount}`
        }
        return planCount
      }
      return Number.isNaN(extCount) ? 0 : extCount
    }
  }
}
</script>

<style lang="scss" scoped>
/* 与 personnel-trajectory-analysis 主页面一致的内联 token（不依赖 @/styles/nx-tokens.scss） */
$nx-color-bg: #f5f7fa;
$nx-color-card: #fff;
$nx-color-text-1: #1f2937;
$nx-color-text-2: #6b7280;
$nx-color-text-3: #909399;
$nx-color-primary: #2563eb;
$nx-color-border: #e5e7eb;
$nx-color-border-2: #ebeef5;
/* 与 Element el-card 圆角 4px 一致 */
$nx-radius-sm: 4px;
$nx-radius-md: 4px;
$nx-radius-lg: 4px;
$nx-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
$nx-space-1: 4px;
$nx-space-2: 8px;
$nx-space-3: 12px;
$nx-space-4: 16px;
$nx-space-5: 20px;
$nx-space-6: 24px;

@mixin nx-surface-card {
  background: $nx-color-card;
  border: 1px solid $nx-color-border-2;
  border-radius: $nx-radius-lg;
  box-shadow: $nx-shadow-sm;
  box-sizing: border-box;
}

.detail-section {
  @include nx-surface-card;
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.detail-head {
  flex-shrink: 0;
  padding: $nx-space-4 $nx-space-5 0;
  margin-bottom: 0;
}

.detail-head.nx-card-header {
  border-bottom: 1px solid $nx-color-border-2;
  padding-bottom: $nx-space-3;
  margin-bottom: $nx-space-3;
}

.detail-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 $nx-space-5 $nx-space-4;
  display: flex;
  flex-direction: column;
  gap: $nx-space-4;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 3px;
  }
}

.detail-card {
  background: $nx-color-bg;
  border-radius: $nx-radius-md;
  padding: $nx-space-3 $nx-space-4;
  border: 1px solid $nx-color-border;
}

.detail-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: $nx-space-3;
  padding-bottom: $nx-space-2;
  border-bottom: 1px solid $nx-color-border;
  color: $nx-color-text-1;
}

.no-track-note {
  font-size: 12px;
  color: $nx-color-text-3;
  margin-bottom: $nx-space-2;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: $nx-space-3;
  font-size: 13px;
  line-height: 1.5;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-label {
  width: 72px;
  flex-shrink: 0;
  color: $nx-color-text-3;
}

.detail-value {
  flex: 1;
  font-weight: 500;
  color: $nx-color-text-1;
  word-break: break-all;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: $nx-space-3;
}

.stat-cell {
  background: #fff;
  border-radius: $nx-radius-sm;
  padding: $nx-space-3;
  min-height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid $nx-color-border;
  box-shadow: $nx-shadow-sm;
}

.stat-label {
  font-size: 12px;
  color: $nx-color-text-3;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 15px;
  font-weight: 600;
  color: $nx-color-text-1;
  font-variant-numeric: tabular-nums;
}
</style>
